import { render, staticRenderFns } from "./editInspectionItemTitle.vue?vue&type=template&id=bb9ba5b4"
import script from "./editInspectionItemTitle.vue?vue&type=script&lang=js"
export * from "./editInspectionItemTitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports